
import { Component, DoCheck, HostListener, Inject, OnInit, ViewEncapsulation, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { CartItem } from '../../classes/cart-item';
import { CartService } from '../../services/cart.service';
import { LandingFixService } from '../../services/landing-fix.service';
import { WINDOW } from '../../services/windows.service';
import { SearchService } from './../../services/search.service';

declare var $: any;

@Component({
    selector: 'app-header-one',
    templateUrl: './header-one.component.html',
    styleUrls: ['./header-one.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderOneComponent implements OnInit, DoCheck {

    public shoppingCartItems: CartItem[] = [];
    searchArticle: string;
    constructor(@Inject(DOCUMENT) private document: Document,
                @Inject(WINDOW) private window, private fix: LandingFixService, private cartService: CartService,
                private router: Router, private searchService: SearchService) {
        this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
        this.searchService.getNameToFind().subscribe(name => this.searchArticle = name);
    }

    ngDoCheck(): void {
    }

    ngOnInit() {
        $.getScript('assets/js/menu.js');
    }

    openNav() {
        this.fix.addNavFix();
    }

    closeNav() {
        this.fix.removeNavFix();
    }


    @HostListener('window:scroll', [])
    onWindowScroll() {
        const number = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
        if (number >= 300) {
            this.document.getElementById('sticky').classList.add('fixed');
        } else {
            this.document.getElementById('sticky').classList.remove('fixed');
        }
    }

    findWeb() {
        if (this.searchArticle && this.searchArticle.trim() !== '') {
            this.router.navigate(['search/', this.searchArticle.trim()]);
        } else {
            this.router.navigate(['/']);
        }

    }

    get cartCount(): number {
        return this.shoppingCartItems.reduce((total, item) => total + item.quantity, 0);
    }

    goHome() {
        this.searchService.vaciarProductoABuscar();
        this.router.navigate(['/home']);
    }
}
